import { render, staticRenderFns } from "./PvpBattleScreen.vue?vue&type=template&id=c8f08928&scoped=true"
import script from "./PvpBattleScreen.vue?vue&type=script&lang=js"
export * from "./PvpBattleScreen.vue?vue&type=script&lang=js"
import style0 from "./PvpBattleScreen.vue?vue&type=style&index=0&id=c8f08928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f08928",
  null
  
)

export default component.exports